import { ABOUT, ASSETS } from "@/data/content";

export const AboutAwards = () => {
  return (
    <section data-testid="about-section" className="bg-[#fafafa] py-14 md:py-20 border-y border-[#f1f1f1]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Intro */}
        <h5 className="font-nunito text-lg md:text-xl font-bold text-[#383838] leading-relaxed max-w-4xl">
          {ABOUT.intro}
        </h5>

        {/* Block 1 */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-[320px,1fr] gap-7 md:gap-10 items-start">
          <img
            src={ABOUT.block1.image}
            alt="Slingshot SEO strategy session"
            className="w-full h-52 md:h-48 object-cover rounded-[12px] shadow-[0_10px_30px_rgba(2,2,2,0.08)]"
            loading="lazy"
          />
          <div className="space-y-4">
            {ABOUT.block1.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-[15px] text-[#6e6e6e] leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>

        {/* Block 2 */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-[320px,1fr] gap-7 md:gap-10 items-start">
          <img
            src={ABOUT.block2.image}
            alt="Performance marketing analytics"
            className="w-full h-52 md:h-48 object-cover rounded-[12px] shadow-[0_10px_30px_rgba(2,2,2,0.08)]"
            loading="lazy"
          />
          <div className="space-y-4">
            {ABOUT.block2.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-[15px] text-[#6e6e6e] leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>

        {/* Awards strip — locked trust asset */}
        <div className="mt-14 text-center">
          <p className="font-nunito text-[11px] font-extrabold uppercase tracking-[0.3em] text-[#9a9a9a] mb-6">
            Awards &amp; Recognition
          </p>
          <img
            src={ASSETS.awardsStrip}
            alt="Slingshot SEO awards and recognition"
            data-testid="awards-strip-image"
            className="mx-auto w-full max-w-4xl h-auto"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};
